import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export const validWidthValues = ['narrow', 'default', 'wide'];
import { map } from '../breakpoint';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Container = styled(_ref => {
  let {
    width,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "data-mesh-component": "CONTAINER",
    ...rest
  });
})`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  ${_ref2 => {
  let {
    width = 'default'
  } = _ref2;
  return map(width, val => val && `max-width: ${getValidContainerWidth(val)};`);
}};
`;
export const getValidContainerWidth = width => {
  switch (width) {
    case 'narrow':
      return `var(--commonDimensionContainerNarrow, '50rem')`;
    case 'wide':
      return `var(--commonDimensionContainerWide, '100rem')`;
    case 'default':
    default:
      return `var(--commonDimensionContainer, '75rem')`;
  }
};
Container.displayName = 'Container';